<app-box class="noFertilityStatus" [@slideIn]>
  <!-- Device image -->
  <div class="noFertilityStatus__graphic">
    @if (hwId() === HardwareId.UEBE_THERMOMETER) {
      <img
        class="noFertilityStatus__thermometer noFertilityStatus__thermometer--uebe ion-padding-horizontal"
        [src]="'./assets/img/fertility-blocker/thermometer-uebe--' + tempScale() + '.svg'"
        [alt]="'cart-THERMOMETER' | tr"
      />
    } @else if (hwId() === HardwareId.T3_THERMOMETER) {
      <img
        class="noFertilityStatus__thermometer"
        [src]="'./assets/img/fertility-blocker/thermometer-t3--' + tempScale() + '.png'"
        [alt]="'cart-THERMOMETER' | tr"
      />
    } @else if (hwId() === HardwareId.APPLE_WATCH) {
      <img
        class="noFertilityStatus__thermometer"
        width="150px"
        src="./assets/img/apple-watch.png"
        [alt]="'cart-APPLE_WATCH' | tr"
      />
    } @else if (hwId() === HardwareId.B1) {
      <img
        class="noFertilityStatus__b1"
        width="164px"
        src="https://www.datocms-assets.com/21281/1742667943-b1-band.png"
        [alt]="'cart-B1' | tr"
        datoImage
        [imgixWidth]="350"
      />
    } @else if (countryCode() === 'AU') {
      <img
        class="noFertilityStatus__thermometer"
        [src]="'./assets/img/fertility-blocker/thermometer-t1--celsius--AU.png'"
        [alt]="'cart-THERMOMETER' | tr"
      />
    } @else if (activationChannel() === ActivationChannel.CLEARBLUE) {
      <img
        class="noFertilityStatus__thermometer"
        [src]="'./assets/img/fertility-blocker/thermometer-t1--clearblue.png'"
        [alt]="'cart-THERMOMETER' | tr"
      />
    } @else {
      <img
        class="noFertilityStatus__thermometer"
        [src]="'./assets/img/fertility-blocker/thermometer-t1--' + tempScale() + '.png'"
        [alt]="'cart-THERMOMETER' | tr"
      />
    }
  </div>

  <!-- Fertility blocker text -->
  <div class="noFertilityStatus__content ion-text-center">
    @if (hwId() === HardwareId.APPLE_WATCH) {
      <h2 class="noFertilityStatus__title" [tmd]="'no-fertility-status-title--APPLE_WATCH'"></h2>

      <div class="noFertilityStatus__body" [tmd]="'no-fertility-status-txt--APPLE_WATCH'"></div>
    } @else if (hwId() === HardwareId.B1) {
      <h2 class="noFertilityStatus__title">{{ 'no-fertility-status-title--B1' | tr }}</h2>

      <div class="noFertilityStatus__body">
        {{ 'no-fertility-status-txt--B1' | tr }}
      </div>
    } @else {
      <h2 class="noFertilityStatus__title">{{ 'no-fertility-status-title' | tr }}</h2>

      <div class="noFertilityStatus__body">
        {{ 'no-fertility-status-txt--' + state() | tr }}
      </div>
    }
  </div>

  <!-- Fertility blocker buttons -->
  <div class="noFertilityStatus__cta">
    @if (hwId() === HardwareId.APPLE_WATCH) {
      <div class="ion-padding-bottom">
        <ion-button
          uid="pageToday__lockedStatus__connectAWBtn"
          class="noFertilityStatus__ctaBtn"
          shape="round"
          expand="block"
          (click)="clickCta.emit(FertilityBlockerCTA.AW_CONNECTION)"
        >
          <ion-label [innerHTML]="'txt-connect--APPLE_WATCH' | tr" />
        </ion-button>
      </div>
    } @else if (hwId() === HardwareId.B1) {
      <div class="ion-padding-bottom">
        <ion-button
          uid="pageToday__lockedStatus__connectB1Btn"
          class="noFertilityStatus__ctaBtn"
          shape="round"
          expand="block"
          [routerLink]="ROUTES.B1PairingPage"
        >
          <ion-label>{{ 'txt-start-setup' | tr }}</ion-label>
        </ion-button>
      </div>
    } @else if (isNoThermState() && canDeliver()) {
      <ion-button
        uid="pageToday__lockedStatus__buyThermBtn"
        class="noFertilityStatus__ctaBtn"
        shape="round"
        expand="block"
        (click)="clickCta.emit(FertilityBlockerCTA.BUY_THERMOMETER)"
      >
        <ion-label>{{ 'txt-buy-now' | tr }}</ion-label>
      </ion-button>

      @if (state() === FertilityBlockerState.NO_THERM) {
        <ion-button
          uid="pageToday__lockedStatus__calibrateBtn"
          fill="outline"
          shape="round"
          expand="block"
          (click)="clickCta.emit(FertilityBlockerCTA.CALIBRATE)"
        >
          <ion-label>{{ 'txt-have-therm' | tr }}</ion-label>
        </ion-button>
      }
    } @else if (state() === FertilityBlockerState.CONNECTED_THERM_UNPAIRED) {
      <ion-button
        uid="pageToday__lockedStatus__connectedThermPair"
        class="noFertilityStatus__ctaBtn"
        shape="round"
        expand="block"
        (click)="clickCta.emit(FertilityBlockerCTA.THERMOMETER_CONNECTION)"
      >
        <ion-label>{{ 'txt-pair-thermometer' | tr }}</ion-label>
      </ion-button>
    } @else {
      <ion-button
        uid="pageToday__lockedStatus__addData"
        class="noFertilityStatus__ctaBtn"
        shape="round"
        expand="block"
        (click)="clickCta.emit(FertilityBlockerCTA.ADD_DATA)"
      >
        <ion-label>{{ 'txt-add-data' | tr }}</ion-label>
      </ion-button>
    }
  </div>
</app-box>
